import type { de } from './de';

/** Mirrors the German tree exactly; TypeScript enforces the shape. */
export const en: typeof de = {
  nav: {
    projects: 'Projects',
    services: 'Services',
    process: 'Process',
    advantages: 'Advantages',
    contact: 'Contact',
    request: 'Book a consultation',
  },
  hero: {
    eyebrow: 'Your concept for your PV system',
    title: 'Transparent. Simple. Cheaper.',
    subtitle:
      'PV Yourself is a well-thought-out concept that lets you save up to {{percent}}%. You order your PV components directly from the wholesaler — without the mark-ups other companies add on top.',
    badge: 'Save up to {{percent}}%',
    badgeNote: 'by buying direct from the wholesaler',
    ctaPrimary: 'Book a consultation',
    ctaSecondary: 'See our services',
  },
  pillars: {
    title: 'Your price advantage, explained',
    direct: { title: 'Order direct, no mark-up', body: 'You order the agreed components directly from the wholesaler — with no additional trade mark-ups.' },
    savings: { title: 'Save up to {{percent}}%', body: 'Buying direct saves you up to {{percent}}% compared with conventional offers.' },
    transparent: { title: 'Transparent and fair', body: 'You know which components you get, what they cost and what you are paying for.' },
  },
  services: {
    eyebrow: 'Our services',
    title: 'Everything from one source — for your energy future',
    subtitle: 'From planning to annual maintenance, we support your project end to end.',
  },
  process: {
    eyebrow: 'In 5 steps',
    title: 'Your path to your own PV system',
    step: 'Step {{number}}',
  },
  trust: {
    eyebrow: 'Experience that builds trust',
    title: 'Why Plan & Volt',
    items: [
      'Developed from years of experience in the photovoltaics industry',
      'Registered with the Chamber of Skilled Crafts',
      'Registered with the grid operator',
      'Professional execution by qualified electricians',
    ],
    proven: { title: 'Proven concept', body: 'Developed from years of experience and proven thousands of times in practice.' },
    price: { title: 'Maximum price advantage', body: 'You save up to {{percent}}% by buying direct from the wholesaler.' },
    transparency: { title: 'Full transparency', body: 'Clear prices, traceable processes and no hidden costs.' },
    fair: { title: 'Fair & reliable', body: 'Honest advice, transparent processes and on-schedule delivery.' },
  },
  contact: {
    eyebrow: 'Contact',
    title: 'Book your consultation',
    subtitle: 'Leave your details — we will get in touch shortly to arrange an on-site appointment.',
    callUs: 'Call us',
    whatsappUs: 'Message us on WhatsApp',
    whatsappCta: 'Open chat',
    whatsappDraft: 'Hello, I am interested in a PV system and would like a consultation.',
    writeUs: 'Write to us',
    closing: 'We look forward to hearing from you!',
  },
  form: {
    name: 'Name',
    email: 'Email',
    phone: 'Phone',
    street: 'Street and number',
    postalCode: 'Postcode',
    city: 'City',
    availability: 'When can we reach you?',
    availabilityHelper: 'e.g. Mon–Fri after 5 pm, or Saturday mornings',
    preferredAt: 'Preferred appointment (optional)',
    interest: 'What are you interested in?',
    message: 'Your message (optional)',
    consent: 'I have read the privacy policy and consent to my data being processed to handle my request.',
    submit: 'Send request',
    submitting: 'Sending…',
    successTitle: 'Thank you for your request!',
    successBody: 'We have received your request and will get back to you shortly. A confirmation is on its way to your inbox.',
    another: 'Send another request',
    errorTitle: 'Your request could not be sent',
    errorBody: 'Please try again or call us directly.',
    required: 'Required',
  },
  validation: {
    name: 'Please enter your name (at least 2 characters).',
    email: 'Please enter a valid email address.',
    phone: 'Please enter a valid phone number.',
    consent: 'Your consent is required.',
    tooLong: 'This text is too long.',
  },
  interests: {
    PV_ANLAGE: 'PV system',
    WECHSELRICHTER: 'Inverter',
    SPEICHER: 'Battery storage',
    WALLBOX: 'Wallbox',
    BALKONKRAFTWERK: 'Balcony power plant',
    WARTUNG: 'Maintenance',
    SONSTIGES: 'Something else',
  },
  projects: {
    eyebrow: 'References',
    title: 'Completed projects',
    subtitle: 'A selection of systems we have planned and installed.',
    viewAll: 'View all projects',
    none: 'No projects have been published yet.',
    notFound: 'That project could not be found.',
    backToList: 'Back to projects',
    factLocation: 'Location',
    factSize: 'System size',
    factCompleted: 'Completed',
    factComponents: 'Components',
    ctaTitle: 'Interested in a system like this?',
  },
  footer: {
    tagline: 'Your system. Your decision. Your price advantage.',
    legal: 'Legal',
    imprint: 'Imprint',
    privacy: 'Privacy policy',
    rights: 'All rights reserved.',
    adminLogin: 'Admin login',
  },
  common: {
    language: 'Language',
    toggleTheme: 'Toggle theme',
    back: 'Back',
    loading: 'Loading…',
    error: 'Something went wrong',
    retry: 'Try again',
    notFoundTitle: 'Page not found',
    notFoundBody: 'The page you requested does not exist.',
    home: 'Go to homepage',
  },
};
